import React, {useMemo} from 'react';
import moment from 'moment';
import {Dropdown} from '../../../shared/ui/Dropdown';

const ConfigVersionSelector = ({configs, activeConfig, selectedConfig, onSelect}) => {
  const options = useMemo(() => {
    const items = configs.map((c, index) => {
      const isActive = activeConfig && moment(c.created.toDate()).isSame(activeConfig);
      const dateLabel = moment(c.created.toDate()).format('DD.MM.YYYY HH:mm:ss');
      const activeLabel = isActive ? ' (Active)' : '';
      const noteLabel = c.note ? ` — ${c.note}` : '';
      return {
        value: index,
        label: `${dateLabel}${activeLabel}${noteLabel}`,
      };
    });
    return items;
  }, [configs, activeConfig]);

  return (
    <Dropdown
      options={options}
      value={selectedConfig}
      onChange={onSelect}
      placeholder="Select Config"
      style={{width: 'auto', minWidth: '350px'}}
    />
  );
};

export default ConfigVersionSelector;

